<template>
  <Card variant="outline" size="medium">
    <template #header>
      <Text variant="h4">Attached files</Text>
      <slot name="actions" />
    </template>

    <View gap="md" direction="column">
      <div>
        <Text variant="label-medium" color="tertiary">Photo ID</Text>
        <FileList gap="sm" variant="ghost" :files="photoIds" />
      </div>

      <div>
        <Text variant="label-medium" color="tertiary">Proof of Income</Text>
        <FileList gap="sm" variant="ghost" :files="proofsOfIncome" />
      </div>

      <div>
        <Text variant="label-medium" color="tertiary">Additional information</Text>
        <FileList gap="sm" variant="ghost" :files="additionalDocuments" />
      </div>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, Text, View } from '@tallo/design-system';
import { FileList } from '@tallo/file-manager';

import { ApplicationDto } from '../../interfaces/application.interface';

const props = defineProps<{ application: ApplicationDto }>();

const photoIds = computed(() => props.application.photoIds);
const proofsOfIncome = computed(() => props.application.proofsOfIncome);
const additionalDocuments = computed(() => props.application.additionalDocuments);
</script>

<style scoped lang="scss"></style>
